import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { ScrollLink } from '../ScrollLink';
import { jsx as _jsx } from "react/jsx-runtime";
const ViewPricingLink = () => {
  return /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-pages-ui.pagesV2.commerce.viewPricing",
        options: {
          viewPricingLink: /*#__PURE__*/_jsx(ScrollLink, {
            targetId: "payments-section",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.pagesV2.commerce.viewPricingLink"
            })
          })
        }
      })
    })
  });
};
export default ViewPricingLink;